import { render } from "./Quadruple.vue?vue&type=template&id=ffa6d7ec&scoped=true&ts=true"
import script from "./Quadruple.vue?vue&type=script&lang=ts"
export * from "./Quadruple.vue?vue&type=script&lang=ts"

import "./Quadruple.vue?vue&type=style&index=0&id=ffa6d7ec&scoped=true&lang=css"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffa6d7ec"]])

export default __exports__